import React from "react";
type IProps = { 
    color?: string;
    children: any 
};

const InspectorInfoField: React.FC<IProps> = ({children, color}: IProps) => {
    
    const getClassName = () => {
        switch (color) {
            case "red": return "inspector-info-field red";
            case "yellow": return "inspector-info-field yellow";
            case "green": return "inspector-info-field green";
            case "cyan": return "inspector-info-field cyan";
            case "magenta": return "inspector-info-field magenta";
            default: return "inspector-info-field";
        }
    };
    
    return (
        <div className={getClassName()}>
            {children ?? "-"}
        </div>  
    );
};
export default InspectorInfoField;